// types
export interface ImageProps {
    className?: string
    src?: {
        src: string
        width?: number
        height?: number
    }
    srcLarge?: {
        src: string
        width?: number
        height?: number
    }
    srcMedium?: {
        src: string
        width?: number
        height?: number
    }
    srcSmall?: {
        src: string
        width?: number
        height?: number
    }
    alt?: string
    sizes?: string
    lazyLoad?: boolean
}

export default function Image({
    className,
    src,
    srcLarge,
    srcMedium,
    srcSmall,
    alt = '',
    sizes,
    lazyLoad = true
}: ImageProps) {

    const defaultSizes = sizes || `
        (max-width: 575px) 100vw,
        (max-width: 992px) 50vw,
        (max-width: 1200px) 50vw,
        ${src?.width}px
    `

    const srcSet = [
        srcSmall && `${srcSmall.src} 575w`,
        srcMedium && `${srcMedium.src} 992w`,
        srcLarge && `${srcLarge.src} 1200w`,
        `${src?.src} ${src?.width}w`
    ].filter(Boolean).join(', ')

    return (
        <img
            alt={alt || ''}
            width={src?.width}
            height={src?.height}
            srcSet={srcSet}
            sizes={defaultSizes}
            src={src?.src}
            className={className}
            loading={lazyLoad ? 'lazy' : 'eager'}
        />
    )
}